import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

const GALLERY_GAP_COLUMN_DESKTOP = 28;
const GALLERY_GAP_COLUMN_MOBILE = 6;

const GALLERY_COLUMN_NUMBER_DESKTOP = 4;
const GALLERY_COLUMN_NUMBER_MOBILE = 2;

export const GalleryModuleContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto',

    [theme.screen.max.laptop]: {
        '& > div': {
            marginLeft: pxToRem(GALLERY_GAP_COLUMN_MOBILE),
            '&:nth-child(2n-1)': {
                // Remove the margin left for the first element of each row
                marginLeft: 0,
            },
            ':nth-child(n+3)': {
                // set marginTop from all element but the 2 first ones
                marginTop: pxToRem(GALLERY_GAP_COLUMN_MOBILE),
            },
        },
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginLeft: pxToRem(GALLERY_GAP_COLUMN_DESKTOP),
            '&:nth-child(4n-3)': {
                // Remove the margin left for the first element of each row
                marginLeft: 0,
            },
            ':nth-child(n+5)': {
                // set marginTop from element 5 to 8
                marginTop: pxToRem(GALLERY_GAP_COLUMN_DESKTOP),
            },
        },
        width: pxToRem(1820),
        justifyContent: 'center',
    },
});

export const ImageContainer: StyleRule = ({ theme }) => ({
    width: `calc(50% - ${pxToRem(
        GALLERY_GAP_COLUMN_MOBILE / GALLERY_COLUMN_NUMBER_MOBILE,
    )})`,
    aspectRatio: 1,

    [theme.screen.tablet]: {
        width: `calc(25% - ${pxToRem(
            (GALLERY_GAP_COLUMN_DESKTOP * (GALLERY_COLUMN_NUMBER_DESKTOP - 1)) /
                GALLERY_COLUMN_NUMBER_DESKTOP,
        )})`,
    },
});
